import { render, staticRenderFns } from "./PromotionTargetConditionMaximumApplicableItems.vue?vue&type=template&id=1390e1a6&"
import script from "./PromotionTargetConditionMaximumApplicableItems.vue?vue&type=script&lang=ts&"
export * from "./PromotionTargetConditionMaximumApplicableItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports